import { Stack, Button, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const PageNotFound = () => {
    const navigate = useNavigate();
    const [t] = useTranslation('global');
    return (React.createElement(Stack, { justifyContent: 'center', flexDirection: 'row', alignItems: 'center' },
        React.createElement(Typography, null,
            t('unAuthPage.pageNotFound'),
            " :("),
        React.createElement(Button, { onClick: () => navigate(-1) }, t('unAuthPage.goBack'))));
};
export default PageNotFound;
